<template>
  <v-card class="mobile-service">
    <!-- Warranty Step -->
    <v-card-title
      v-if="isWarrantyStep"
      class="mobile-service__close pa-0"
    >
      <v-btn icon>
        <v-icon
          small
          @click="close()"
        >
          close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      v-if="isWarrantyStep"
      class="pa-0 mobile-service__title"
    >
      Seguro Mobile
    </v-card-text>

    <v-card-text
      v-if="isWarrantyStep"
      class="pa-0 my-1 mb-2 mobile-service__txt"
    >
      Proteja seu dispositivo móvel por muito mais tempo.
    </v-card-text>

    <v-card-text
      v-if="isWarrantyStep"
      class="pa-0 my-1 mb-3 mobile-service__sub"
    >
      Selecione o prazo de proteção
      <a
        target="_blank"
        href="https://vuetifyjs.com"
      >
        SEGURO MOBILE
      </a>
      e mantenha seu produto protegido por mais tempo além da garantia oferecida pelo fabricante, você conta com vantagens exclusivas.
    </v-card-text>

    <v-form
      v-if="isWarrantyStep"
      v-model="valid"
    >
      <v-container
        fluid
        class="dialog-container"
      >
        <!-- Desabilitado para V0 (por padrão vem a opção todas as unidades selecionadas) -->
        <!-- <v-autocomplete
          v-if="quantity > 1"
          v-model="unitiesToApply"
          :items="getQuantities"
          label="Para quantas unidades deseja aplicar?"
          required
        /> -->

        <v-radio-group v-model="selectedWarranty">
          <v-radio
            class="dialog-radio"
            color="#140C22"
            :value="null"
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  Sem seguro mobile
                </span>
              </div>
            </template>
          </v-radio>
          <v-radio
            v-for="(warranty, index) in otherWarranties"
            :key="index"
            :value="warranty"
            class="dialog-radio"
            color="#140C22"
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ warranty.title }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ warranty.subtitle }}
                </span>
              </div>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ warranty.price | currency }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ warranty.installments }}
                </span>
              </div>
            </template>
          </v-radio>
          <span
            class="advise"
          >
            Recomendado
          </span>
          <v-radio
            :value="recommendedWarranty"
            class="dialog-radio"
            color="#140C22"
            style="border: 1px solid #140C22"
            mandatory
          >
            <template #label>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ recommendedWarranty.title }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ recommendedWarranty.subtitle }}
                </span>
              </div>
              <div class="dialog-radio__wrapper">
                <span
                  class="dialog-radio__wrapper__title"
                >
                  {{ recommendedWarranty.price | currency }}
                </span>
                <span
                  class="dialog-radio__wrapper__txt"
                >
                  {{ recommendedWarranty.installments }}
                </span>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-container>

      <!-- to be used in upcoming versions of sales assistant -->
      <!-- <v-container
        fluid
        class="dialog-conditions"
      >
        <v-checkbox
          v-model="selectedTerms"
          color="black"
          :rules="[(v) => !!v || 'Campo Obrigatório!']"
        >
          <template
            #label
            required
          >
            <div
              class=" pl-2 dialog-conditions__txt"
            >
              Li e aceito os
              <a
                target="_blank"
                href="https://vuetifyjs.com"
                class="dialog-conditions__link"
              >
                Termos de acordo
              </a>
              e
              <a
                target="_blank"
                href="https://google.com"
                class="dialog-conditions__link"
              >
                Informações Legais.
              </a>
              Caso não esteja de acordo, proceda sua compra sem a Garantia Estendida Original.
            </div>
          </template>
        </v-checkbox>
      </v-container> -->

      <v-card-actions
        class="mobile-service__actions pa-0 ma-0 mt-1"
      >
        <v-btn
          class="mobile-service__btn"
          medium
          depressed
          :disabled="!unitiesToApply"
          color="#140C22"
          @click="nextStep()"
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-form>

    <!-- Imei Step -->
    <v-card-title
      v-if="isImeiStep"
      class="mobile-service__close pa-0"
    >
      <v-flex
        xs12
        text-xs-center
      >
        <v-layout
          row
          wrap
          style="justify-content: space-between"
        >
          <div class="mobile-service__back">
            <v-btn
              flat
              icon
              color="primary"
              @click="backStep"
            >
              <v-icon>
                $vuetify.icons.arrowLeftIcon
              </v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              class="back"
              @click="backStep"
            >
              Voltar
            </v-btn>
          </div>

          <v-btn icon>
            <v-icon
              small
              @click="close()"
            >
              close
            </v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-card-title>

    <v-card-text
      v-if="isImeiStep"
      class="pa-0 mobile-service__title"
    >
      Seguro Mobile
    </v-card-text>

    <v-card-text
      v-if="isImeiStep"
      class="pa-0 my-1 mb-2 mobile-service__txt"
    >
      Proteja seu dispositivo móvel por muito mais tempo.
    </v-card-text>

    <v-card-text
      v-if="isImeiStep"
      class="pa-0 my-1 mb-3 mobile-service__sub"
    >
      Adicione o IMEI do seu dispositivo móvel ao registro do seguro mobile.
    </v-card-text>

    <v-form
      v-if="isImeiStep"
      ref="form"
      v-model="valid"
    >
      <v-container
        fluid
        class="dialog-container"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            v-for="(item, index) in getImeis"
            :key="index"
            :value="index"
            xs12
            class="py-0 px-6"
          >
            <span> IMEI {{ index + 1 }} </span>
            <v-text-field
              v-model="getImeis[index]"
              placeholder="Informe o IMEI do dispositivo"
              solo
              :maxlength="maxLength"
              :rules="[ruleImei]"
              class="mt-1"
            />
          </v-flex>
        </v-layout>
      </v-container>

      <v-card-actions class="mobile-service__actions pa-0 ma-0 mt-1">
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-btn
              class="mobile-service__btn mb-3"
              medium
              depressed
              color="#140C22"
              :disabled="!valid"
              @click="addMobileWarranty()"
            >
              Confirmar
            </v-btn>
          </v-flex>

          <v-flex xs12>
            <v-btn
              class="mobile-service__btn"
              medium
              depressed
              outline
              color="#140C22"
              @click="close()"
            >
              Cancelar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import orderBy from 'lodash.orderby';
import verifyImei from '../../utils/verifyImei';

export default {
  props: {
    product: {
      type: Object,
      default: () => { },
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    warranties: [
      {
        title: 'Proteção simples',
        subtitle: '12 meses de seguro',
        price: 183.36,
        installments: 'em até 10x de R$18,33',
        recomended: false,
      },
      {
        title: 'Proteção tela',
        subtitle: '12 meses de seguro',
        price: 183.36,
        installments: 'em até 10x de R$18,33',
        recomended: false,
      },
      {
        title: 'Proteção total',
        subtitle: '12 meses de seguro',
        price: 183.36,
        installments: 'em até 10x de R$18,33',
        recomended: true,
      },
    ],
    selectedWarranty: null,
    valid: null,
    unitiesToApply: undefined,
    isImeiStep: false,
    isWarrantyStep: true,
    maxLength: 20,
  }),

  computed: {
    ...mapGetters([
      'getCatalogue',
      'getStore',
    ]),

    getSkuAddOns() {
      let skuAddOnsWithRecommended = this.product.skus[0].sku_add_ons.filter((skuAddOn) => skuAddOn.type === 'SM' && skuAddOn.store_id === this.product.store_id).map((skuAddOn) => ({
        sku_add_on_id: skuAddOn.id,
        title: `+ ${skuAddOn.plan} ${skuAddOn.plan > 1 ? 'Meses' : 'Mês'}`,
        subtitle: skuAddOn.description || 'Seguro Mobile',
        price: skuAddOn.price_plan,
        installments: `em até 10x de ${(skuAddOn.price_plan / 10).toFixed(2)}`,
        recommended: false,
      }));

      if (skuAddOnsWithRecommended.length) {
        const skuAddOnWithMaxPlan = skuAddOnsWithRecommended.reduce((prev, current) => ((prev.price > current.price) ? prev : current));

        skuAddOnsWithRecommended = skuAddOnsWithRecommended.map((skuAddOn) => ({
          ...skuAddOn,
          recommended: skuAddOn.price === skuAddOnWithMaxPlan.price,
        }));

        return orderBy(skuAddOnsWithRecommended, 'price');
      }

      return [];
    },

    otherWarranties() {
      return this.getSkuAddOns.filter((warranty) => !warranty.recommended);
    },

    recommendedWarranty() {
      return this.getSkuAddOns.find((warranty) => warranty.recommended);
    },

    getQuantities() {
      const items = [{
        value: this.quantity,
        text: 'Todas as unidades',
      }];
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= this.quantity; i++) {
        items.push({ value: i, text: i });
      }
      return items;
    },

    getImeis() {
      return this.unitiesToApply ? Array(this.unitiesToApply) : Array(this.quantity);
    },
  },

  watch: {
    product: {
      handler() {
        this.selectedWarranty = this.product.warrantyMobile || null;
      },
      deep: true,
      immediate: true,
    },
    quantity() {
      this.unitiesToApply = this.getQuantities[0].value;
    },
  },

  mounted() {
    this.selectedWarranty = this.product.warrantyMobile || this.recommendedWarranty;
    this.unitiesToApply = this.getQuantities[0].value;
  },

  methods: {
    ruleImei(value) {
      if (!value) {
        return 'Campo Obrigatório';
      }
      if (!verifyImei(value)) {
        return 'IMEI Inválido';
      }
      if (this.getCatalogue.filter((item) => item.imei === value).length || this.getImeis.filter((item) => item === value).length > 1) {
        return 'IMEI já utilizado';
      }
      return true;
    },

    close() {
      this.$emit('close', false);
    },

    backStep() {
      this.isImeiStep = false;
      this.isWarrantyStep = true;
    },

    nextStep() {
      // @TODO => adicionar um identificador que a loja é CD
      // para não precisar deixar hardcoded o id da loja específica (em breve teremos mais lojas no estilo CD)
      if (this.selectedWarranty && !this.product.imei && this.getStore.id !== '52') {
        this.isImeiStep = true;
        this.isWarrantyStep = false;
      } else {
        this.addMobileWarranty();
      }
    },

    addMobileWarranty() {
      if (this.valid) {
        this.$set(this.product, 'warrantyMobile', this.selectedWarranty);
        if (this.selectedWarranty && this.getStore.id !== '52') {
          this.$set(this.product, 'imeis', this.getImeis);
        } else {
          this.$set(this.product, 'imeis', undefined);
          this.$set(this.product, 'imei', undefined);
        }
        this.$emit('change-quantity-warranty', this.unitiesToApply);
        this.$emit('finish-warranty');
        this.$store.dispatch('refreshCatalogue');
        this.backStep();
        this.$emit('close');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-service {
  padding: 0px 20px 40px 20px;
  text-transform: none;
  border-radius: 7px;
  color: #140C22;
  box-sizing: border-box;
  &__title {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    text-transform: uppercase;
  }
  &__txt {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
  }
  &__sub {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-transform: none;
  }
  &__actions {
    align-items: center;
    justify-content: center;
  }
  &__btn {
    width: 290px;
    height: 38px;
    border-radius: 7px;
    text-transform: none;
    font-weight: 600;
    color: #FFFFFF;
  }
  &__close {
    display: flex;
    justify-content: end;
    transform: translateX(15px);
  }
}

.dialog-container {
  padding: 0px;
  width: 100%;
}

.dialog-radio {
  border: 1px solid rgba(20, 12, 34, 0.25);
  border-radius: 7px;
  padding: 0.3rem 1.2rem;
  width: 100%;
  &__wrapper {
    padding: 0.4rem 0.6rem;
    &__title {
      color: #140C22;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
    }
    &__txt {
      color: #8A8691;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.dialog-conditions {
  padding: 0px;
  margin-top: -30px;
  &__txt {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: rgba(20, 12, 34, 0.5);
  }
  &__link {
    color: #046CB8;
  }
}

::v-deep .dialog-conditions .v-input__slot {
  align-items: flex-start;
}

::v-deep .v-list__tile {
  border-bottom: none;
}

::v-deep .v-autocomplete {
  width: 101%;
}

::v-deep .v-select__slot {
  font-family: 'Roboto';
}

::v-deep .v-list__tile {
  height: 40px;
}

.v-radio {
  margin: 0px;
}

.advise {
  width: 81px;
  height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 8px;
  line-height: 11px;
  background: #3D6961;
  border-radius: 3px;
  color: #FFFFFF;
  text-transform: uppercase;
}

.back {
  text-transform: none;
  margin-right: 24px;
}
  </style>
